import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
} from '@ant-design/icons';

// Inventory Status Options
export const INVENTORY_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Expired', value: 'EXPIRED' },
  { label: 'Recalled', value: 'RECALLED' },
] as const;

// Stock Level Filter Options
export const STOCK_LEVEL_FILTER_OPTIONS = [
  { label: 'Low Stock', value: 'LOW' },
  { label: 'Medium Stock', value: 'MEDIUM' },
  { label: 'High Stock', value: 'HIGH' },
] as const;

// Filter Options
export const STATUS_FILTER_OPTIONS = INVENTORY_STATUS_OPTIONS;

// Status Colors
export const STATUS_COLORS = {
  ACTIVE: 'green',
  EXPIRED: 'red',
  RECALLED: 'orange',
} as const;

// Status Icons
export const STATUS_ICONS = {
  ACTIVE: <CheckCircleOutlined />,
  EXPIRED: <StopOutlined />,
  RECALLED: <ExclamationCircleOutlined />,
} as const;

// Stock Level Colors
export const STOCK_LEVEL_COLORS = {
  LOW: '#ff4d4f',
  MEDIUM: '#fa8c16',
  HIGH: '#52c41a',
} as const;

// Utility function to determine stock level
export const getStockLevel = (
  currentStock: number,
  minStock: number = 0,
  maxStock: number = 100
): 'LOW' | 'MEDIUM' | 'HIGH' => {
  if (currentStock <= minStock) {
    return 'LOW';
  } else if (currentStock <= (minStock + maxStock) / 2) {
    return 'MEDIUM';
  } else {
    return 'HIGH';
  }
};
